import { defineMessages } from "react-intl";

import LeadFinderSubscriptionPlan from "@mapmycustomers/shared/enum/LeadFinderSubscriptionPlan";

import ChecklistDescriptor from "@app/component/flows/types/ChecklistDescriptor";
import Iam from "@app/types/Iam";

import { groupsTour } from "./groupsTour";
import { introductionTour } from "./introductionTour";
import { leadFinderTour } from "./leadFinderTour";
import { segmentPinsTour } from "./segmentPinsTour";

const messages = defineMessages({
  filters: {
    id: "guides.mapOnboarding.checklist.filters",
    defaultMessage: "Drill down with filters",
  },
  groups: {
    id: "guides.mapOnboarding.checklist.groups",
    defaultMessage: "Create and manage groups",
  },
  introduction: {
    id: "guides.mapOnboarding.checklist.introduction",
    defaultMessage: "Map Introduction",
  },
  leadFinder: {
    id: "guides.mapOnboarding.checklist.leadFinder",
    defaultMessage: "Find new business",
  },
  segmentPins: {
    id: "guides.mapOnboarding.checklist.segmentPins",
    defaultMessage: "Segment pins on the map",
  },
  subTitle: {
    id: "guides.mapOnboarding.checklist.subTitle",
    defaultMessage: "Learn your way around the core features of our main mapping experience.",
  },
  title: {
    id: "guides.mapOnboarding.checklist",
    defaultMessage: "Getting Around the Map",
  },
});

export const mapOnboardingConfiguration: ChecklistDescriptor = {
  id: "mmc-maps-onboarding",
  steps: [
    {
      id: "introduction",
      path: "/map",
      title: messages.introduction,
      tour: introductionTour,
    },
    {
      id: "segmentPins",
      path: "/map",
      title: messages.segmentPins,
      tour: segmentPinsTour,
    },
    // {
    //   id: "filters",
    //   path: "/map",
    //   title: messages.filters,
    //   // tour: adminsInitialSetupTour,
    // },
    {
      id: "lead-finder",
      isVisible: (guideId, stepId, me: Iam) => {
        return me.organization.addOnServices.leadGen !== LeadFinderSubscriptionPlan.NONE;
      },
      path: "/map",
      title: messages.leadFinder,
      tour: leadFinderTour,
    },
    {
      id: "groups",
      path: "/map",
      title: messages.groups,
      tour: groupsTour,
    },
  ],
  subTitle: messages.subTitle,
  title: messages.title,
};
